import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/admin/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-perfect-scrollbar/dist/css/styles.css");
;
import(/* webpackMode: "eager" */ "/app/apps/admin/src/app/globals.css");
